import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { toggleMenu } from "store/actions/menu";
import { employeeLogOut } from "store/actions/auth";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";

import { MenuButton, Logo, Title, WrapTopbar } from "components/template/topbar/theme";
import { AppLogo } from "components/theme";

/** Topbar dedicata al dipendente: nessuna notifica e nessun accesso al profilo admin. */
function EmployeeTopbar({ employeeName, employeeLogOut, toggleMenu }) {
  return (
    <WrapTopbar>
      <AppBar position="fixed">
        <Toolbar>
          <MenuButton>
            <IconButton color="inherit" aria-label="Menu" onClick={toggleMenu}>
              <MenuIcon />
            </IconButton>
          </MenuButton>
          <Logo src={AppLogo} alt="" />
          <Title>
            <Typography variant="h6" color="inherit">{employeeName}</Typography>
          </Title>
          <Button color="inherit" onClick={employeeLogOut}>Logout</Button>
        </Toolbar>
      </AppBar>
    </WrapTopbar>
  );
}

const mapStateToProps = (state) => {
  return {
    employeeName: state.auth.employee?.data?.name || "",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    employeeLogOut: bindActionCreators(employeeLogOut, dispatch),
    toggleMenu: bindActionCreators(toggleMenu, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTopbar);
